import { pdfjs } from "react-pdf";

export const pdfjs_version = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;
